import { Component, OnInit } from '@angular/core';
import { Collection } from 'src/app/global/services/collections/collections.model';
import { Subject } from 'rxjs';
import { CollectionsService } from 'src/app/global/services/collections/collections.abstract.service';
import { State } from 'src/app/store';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntil, tap } from 'rxjs/operators';
import { UpdateCollectionSuccessAction, UpdateCollectionErrorAction, UpdateCollectionAction, GetCollectionsAction } from 'src/app/global/store/global.actions';

@Component({
    selector: 'app-collection-edit',
    templateUrl: './collection-edit.component.html',
    styleUrls: ['./collection-edit.component.scss'],
})
export class CollectionEditComponent implements OnInit {
    destroy$ = new Subject();

    collectionId = '';

    collection: Collection;

    loading = false;
    submitLoading = false;

    constructor(
        private route: ActivatedRoute,
        private collectionsService: CollectionsService,
        private router: Router,
        private store: Store<State>,
        private actions$: Actions,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.collectionId = params.get('id');
        });

        this.loading = true;

        this.collectionsService
            .getCollection(this.collectionId)
            .pipe(
                tap(() => {
                    this.loading = false;
                }),
                takeUntil(this.destroy$),
            )
            .subscribe((collection) => {
                this.collection = collection;
            });
    }

    handleSubmit(payload: Collection): void {
        this.submitLoading = true;

        this.store.dispatch(UpdateCollectionAction({ collection: payload }));

        this.actions$
            .pipe(
                ofType(UpdateCollectionSuccessAction, UpdateCollectionErrorAction),
                tap(() => (this.submitLoading = false)),
                ofType(UpdateCollectionSuccessAction),
                tap(() => this.store.dispatch(GetCollectionsAction())),
                tap(() => this.router.navigate(['collections'])),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
